import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import { selectAppId } from 'app/developer-v3/store/selectors';
import {
  currentAppEntity,
  currentAppTitle,
  currentAppVersion,
  currentAppVersionEntities,
  selectPushedBackVersions,
} from 'app/developer-v3/selectors';

import PublishingPage from './PublishingPage';

const mapStateToProps = state => {
  const appId = selectAppId(state);
  const app = currentAppEntity(state);
  const appTitle = currentAppTitle(state);
  const versionEntities = currentAppVersionEntities(state);
  const version = currentAppVersion(state);
  const versions = versionEntities.map(CliAppDefinition.selectors.version);

  return {
    integrationId: Number(appId),
    integrationName: appTitle,
    status: CliApp.selectors.status(app),
    version,
    versions,
    versionsBlocked: selectPushedBackVersions(state),
  };
};

const Container = connect(mapStateToProps)(PublishingPage);

export default Container;
